import Component from './Courses';

export default Component;
